var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('f7-page',[_c('f7-block',{staticClass:"loading"},[_c('f7-preloader',{attrs:{"size":"20px"}}),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',[_vm._v("加载中")])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }